{
  "scope": {
    "my_tasks": "My Tasks",
    "delegated_tasks": "Delegated Tasks"
  },
  "status": {
    "open": "Open",
    "completed": "Completed",
    "overdue": "OVERDUE"
  },
  "dashboard": {
    "section_title": "Your Open Tasks"
  },
  "actions": {
    "create_task": "Create Task",
    "update_task": "Update Task",
    "save_task": "Save Task",
    "cancel_create_task": "Cancel Create Task"
  },
  "form": {
    "labels": {
      "due_date": "Due Date",
      "assigned_to": "Assigned To",
      "requested_by": "Requested By",
      "description": "Description"
    },
    "placeholders": {
      "assigned_to": "assigned to",
      "requested_by": "requested by"
    },
    "validation": {
      "task_required": "Please enter a task",
      "date_too_old": "that's too long ago",
      "date_too_far": "that's too far away",
      "task_name_empty": "Task name cannot be empty",
      "unexpected_error": "An unexpected error occurred while adding the task."
    }
  },
  "table": {
    "headers": {
      "tasks": "Tasks",
      "priority": "Priority",
      "due_date": "Due Date",
      "assigned_to": "Assigned To",
      "source": "Source"
    }
  },
  "delete": {
    "confirmation_message": "Click confirm to delete task",
    "section_confirmation": "Click confirm to delete the section"
  },
  "slide": {
    "labels": {
      "due_date": "Due Date",
      "source": "Source",
      "assigned_to": "Assigned To",
      "requested_by": "Requested By",
      "completed_by": "Completed By",
      "description": "Description",
      "comments": "Comments"
    }
  },
  "sections": {
    "completed": "Completed",
    "without_section": "Tasks Without Section",
    "create": "Create Section",
    "placeholder": "Type Section",
    "validation": {
      "name_empty": "Section name cannot be empty",
      "unexpected_error": "An unexpected error occurred while creating the section."
    }
  },
  "timeframes": {
    "overdue": "Overdue",
    "today": "Today",
    "upcoming": "Upcoming"
  },
  "add_task": {
    "placeholder": "Add new task...",
    "type_new": "Type new task",
    "validation": {
      "name_empty": "Task name cannot be empty",
      "unexpected_error": "An unexpected error occurred while adding the task."
    }
  },
  "form_fields": {
    "placeholders": {
      "assigned_to_question": "Assigned to?",
      "due_date_question": "When is it due?",
      "select_priority": "Select Priority"
    }
  },
  "aria_labels": {
    "create_new_task": "create new task",
    "task_section_actions": "task section actions",
    "mark_completed": "Mark as Completed Task",
    "mark_uncompleted": "Mark as Uncompleted Task",
    "assign_to": "Assign To",
    "select_priority": "select task priority",
    "rename_section": "Rename Section",
    "new_section_name": "New Section Name"
  },
  "empty_state": {
    "title": "No Tasks Yet",
    "description": "Start by creating a task and organizing your work"
  },
  "display": {
    "empty_value": "-"
  },
  "partials_form": {
    "labels": {
      "associated_company": "Associated Company",
      "contact": "Contact",
      "task": "Task",
      "due_date": "Due Date",
      "assign_to": "Assign To"
    },
    "placeholders": {
      "associated_company": "Associated Company",
      "contact": "Contact",
      "describe_task": "Describe the task"
    },
    "validation": {
      "company_required": "please enter a company",
      "task_required": "Please enter a task",
      "date_too_old": "that's too long ago",
      "date_too_far": "that's too far away"
    },
    "buttons": {
      "add_task": "+ Task"
    },
    "modal": {
      "create_title": "Create Task",
      "update_title": "Update Task"
    }
  }
}
